
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.138 31H7.86A6.861 6.861 0 011 24.139V7.863A6.862 6.862 0 017.86 1h16.278a6.863 6.863 0 016.863 6.863v16.276A6.863 6.863 0 0124.138 31","fill":"#00DCF7"}}),_c('path',{attrs:{"d":"M16 12.009a3.22 3.22 0 003.212-3.228 3.22 3.22 0 00-3.213-3.226 3.218 3.218 0 00-3.21 3.226 3.219 3.219 0 003.21 3.228zM14.7 26.552l-.27-.197a2.378 2.378 0 01-.521-3.313l7.42-9.834a2.355 2.355 0 013.3-.525l.268.197a2.381 2.381 0 01.522 3.315l-7.42 9.83a2.355 2.355 0 01-3.3.527zM11.834 22.791l1.624-2.125c.879-1.039 1.204-2.273.438-3.332l-3.227-4.126a2.353 2.353 0 00-3.297-.525l-.27.196a2.381 2.381 0 00-.522 3.314l3.388 4.34 1.866 2.258z","fill":"#fff"}})])
          )
        }
      }
    